import { useState, useEffect } from 'react'
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { useMediaQuery } from '@material-ui/core';
import Description from '@material-ui/icons/Description';

import { useTheme, makeStyles } from '@material-ui/styles'

import PassedQualifiedListItem from './passed-qualified-item'
import UnqualifiedListItem from './unqualified-list-item/index'
import FillingUnqualifiedModal from './filling-unqualified-modal/index'
import AskingValidationModal from './asking-validation-modal/index'
import FastEditModal from './fast-edit-modal/index'

const useStyles = makeStyles(theme => ({
	container: {
		width: '500px',
		overflow: 'scroll',
	},
}))

export default function StandardReportStep4({
	invalidDataSetRecords,
	invalidAnswers,
	onInputValidationReason,
	invalidInputMethod,
	onChangeInvalidaInputMethod,
	openAskingValidationModal,
	onOpenAskingValidationModal,
	onAskInvalidInputMethod,
	currentValiationQuestionNumber,
	openFillingModal,
	onCloseAskingValidationModal,
	onCloseFillingModal,
	currentSelectedItem,
	onFillForm,
	flags,
	quarter,
	fixedGeneralAnswers,
	fixedInfoAnswers,
	fixedSoundAnswers,
	mobileGeneralAnswers,
	mobileInfoAnswers,
	mobileSoundAnswers,
	fixedGeneralDetails,
	fixedInfoDetails,
	fixedSoundDetails,
	mobileGeneralDetails,
	mobileInfoDetails,
	mobileSoundDetails,
	onReValidate,
	reportMethod,
}) {
	const classes = useStyles()
	const theme = useTheme()
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
	const [currentAnswer, setCurrentAnswer] = useState({
		reason: '',
		solution: '',
		periodSolution: null,
		file: null,
	})
	const [activeItem, setActiveItem] = useState(null)

	// Add Re-validate function wrapper
	const handleReValidateClick = () => {
		if (onReValidate) {
			onReValidate();
		}
	}

	const [currentErrorMessage, setCurrentErrorMessage] = useState('')
	const [currentLabel, setCurrentLabel] = useState({ text: '', no: '' })
	const [openFastEdit, setOpenFastEdit] = useState(false)
	const [currentFastEditItem, setCurrentFastEditItem] = useState(null)

	useEffect(() => {
		window.scrollTo(0, 0)
	}, [invalidDataSetRecords])

	useEffect(() => {
		const ans = invalidAnswers.find(
			item => item.id === currentValiationQuestionNumber
		) ?? (currentSelectedItem?.id === currentValiationQuestionNumber ? currentSelectedItem : null)

		if (ans) {
			setCurrentAnswer({
				reason: ans.reason,
				solution: ans.solution,
				periodSolution: ans.periodSolution,
				file: ans.file,
			})
		}
	}, [invalidAnswers, currentValiationQuestionNumber, currentSelectedItem])

	useEffect(() => {
		if (currentSelectedItem) {
			const findError = invalidDataSetRecords.find(
				x => x.id === currentSelectedItem.id
			)
			setCurrentErrorMessage(findError?.errors ?? '')
			if (findError)
				setCurrentLabel({
					text: findError.label,
					no: findError.question_number,
				})
		}
	}, [currentSelectedItem, invalidDataSetRecords])

	const isFillAnswer = id => {
		const ans = invalidAnswers.find(item => item.id === id)
		let fill = false
		if (ans) {
			if (ans.inputMethod === 'message') {
				if (
					ans.periodSolution !== null &&
					ans.reason !== '' &&
					ans.solution !== ''
				) {
					fill = true
				}
			} else if (ans.inputMethod === 'attach') {
				if (ans.file !== null) {
					fill = true
				}
			} else if (ans.inputMethod === 'no_service') {
				if (
					ans.periodSolution !== null &&
					ans.reason !== '' &&
					ans.solution !== ''
				) {
					fill = true
				}
			}
		}
		return fill
	}

	const getAnswersByType = (type) => {
		if (type === 'fixed-general') return fixedGeneralAnswers;
		if (type === 'fixed-info') return fixedInfoAnswers;
		if (type === 'fixed-sound') return fixedSoundAnswers;
		if (type === 'mobile-general') return mobileGeneralAnswers;
		if (type === 'mobile-info') return mobileInfoAnswers;
		if (type === 'mobile-sound') return mobileSoundAnswers;
		return [];
	}

	const getDetailsByType = (type) => {
		if (type === 'fixed-general') return fixedGeneralDetails;
		if (type === 'fixed-info') return fixedInfoDetails;
		if (type === 'fixed-sound') return fixedSoundDetails;
		if (type === 'mobile-general') return mobileGeneralDetails;
		if (type === 'mobile-info') return mobileInfoDetails;
		if (type === 'mobile-sound') return mobileSoundDetails;
		return [];
	}

	const handleFastEdit = (item) => {
		// Robust lookup for question if missing (Stale State Fix)
		let questionItem = item.question
		let formType = item.formType



		if (!questionItem) {
			// If we have formType, try that first
			if (formType) {
				const details = getDetailsByType(formType)
				questionItem = details?.find(d => d.id === item.id)
			}

			// If still not found (no formType or lookup failed), search all datasets
			if (!questionItem) {
				const allDetails = [
					{ type: 'fixed-general', data: fixedGeneralDetails },
					{ type: 'fixed-info', data: fixedInfoDetails },
					{ type: 'fixed-sound', data: fixedSoundDetails },
					{ type: 'mobile-general', data: mobileGeneralDetails },
					{ type: 'mobile-info', data: mobileInfoDetails },
					{ type: 'mobile-sound', data: mobileSoundDetails },
				]

				for (const group of allDetails) {
					const found = group.data?.find(d => d.id === item.id)
					if (found) {
						questionItem = found
						formType = group.type
						break
					}
				}
			}

			if (!questionItem) {
				console.error("Could not find question definition for item:", item)
				return
			}
		}

		// Create a composite item with the question guaranteed
		const editItem = {
			...item,
			question: questionItem,
			formType: formType
		}

		setCurrentFastEditItem(editItem)
		setOpenFastEdit(true)
	}

	const handleCloseFastEdit = () => {
		setOpenFastEdit(false)
		setCurrentFastEditItem(null)
	}

	return (
		<>
			<Grid
				className={`border border-t-4 border-card_top_border border-l-0 border-r-0 border-b-0 my-8  bg-white shadow-lg overflow-scroll `}>
				{/* Header */}
				<Grid className={`flex flex-row items-center gap-x-2 p-3`}>
					<Description style={{ fontSize: 22 }} className="mr-1" />
					<Grid className="font-bold text-sm text-card_header_color">
						ผลการตรวจสอบข้อมูล
					</Grid>
				</Grid>
				<Divider
					className={`w-full bg-black my-4 ${isMobile ? classes.container : ''
						}`}
				/>
				{/* Table Header */}
				<Grid
					className={`flex flex-row p-3 ${isMobile ? classes.container : ''}`}>
					<Grid className="border border-r-1 border-l-0 border-t-0 border-b-0 w-1/12 px-5">
						ข้อ
					</Grid>
					<Grid className="border border-r-1 border-l-0 border-t-0 border-b-0 w-5/12 px-5">
						หัวข้อ
					</Grid>
					<Grid className="border border-r-1 border-l-0 border-t-0 border-b-0 w-3/12 px-5">
						ข้อผิดพลาด
					</Grid>
					<Grid className="w-2/12 px-5 text-center">ให้เหตุผล</Grid>
					<Grid className="w-1/12 px-5 text-center">แก้ไข</Grid>
				</Grid>
				{/* Table Content */}
				{invalidDataSetRecords.map((item, index) => (
					<UnqualifiedListItem
						key={item.question_number + item.label + index}
						question_number={item.question_number}
						label={item.label}
						errorMessage={item.errors}
						isFillAnswer={isFillAnswer(item.id)}
						handleButton={() => {
							onOpenAskingValidationModal(item.id)
						}}
						handleEdit={() => handleFastEdit(item)}
						reportMethod={reportMethod}
					/>
				))}
				{invalidDataSetRecords.length === 0 && <PassedQualifiedListItem />}
				<Grid className="flex flex-row justify-end items-center p-3">
					<Grid className="flex flex-row items-center">
						<Typography variant="body1" color="textSecondary">
							ต้องแก้ไข {invalidDataSetRecords.length} รายการ
						</Typography>

						{reportMethod !== 'upload' && (
							<Button
								variant="contained"
								color="primary"
								className="ml-4"
								onClick={handleReValidateClick}
							>
								ตรวจสอบข้อมูลอีกครั้ง
							</Button>
						)}
					</Grid>
				</Grid>
			</Grid>
			<FillingUnqualifiedModal
				currentSelectedItem={currentSelectedItem}
				id={currentSelectedItem.id}
				question_number={currentLabel.no}
				question_label={currentLabel.text}
				errorMessage={currentErrorMessage}
				currentAnswer={currentAnswer}
				open={openFillingModal}
				onClose={onCloseFillingModal}
				handleButton={onCloseFillingModal}
				onInputValidationReason={onInputValidationReason}
			/>
			<AskingValidationModal
				open={openAskingValidationModal}
				onClose={onCloseAskingValidationModal}
				handleButton={onCloseAskingValidationModal}
				invalidInputMethod={currentSelectedItem.inputMethod}
				onChangeInvalidaInputMethod={onAskInvalidInputMethod}
			/>
			{openFastEdit && currentFastEditItem && (
				<FastEditModal
					open={openFastEdit}
					onClose={handleCloseFastEdit}
					question={currentFastEditItem.question}
					formType={currentFastEditItem.formType}
					answers={getAnswersByType(currentFastEditItem.formType)}
					onFillForm={onFillForm}
					flags={flags}
				/>
			)}
		</>
	)
}
